import PreloadImages from './preload-images'

const SetImages = ($images, images) => {
  $images.forEach(($image, i) => {
    $image.setAttribute('src', images[i])

    if (i === $images.length - 1) {
      setTimeout(() => {
        window.dispatchEvent(new Event('resize'))
      }, 50)
    }
  })
}

const DeferImages = () => {
  const $images = document.querySelectorAll("[defer-image]")

  if (!$images.length > 0) return

  let imagesGroup = []

  $images.forEach(($image, i) => {
    imagesGroup[i] = $image.getAttribute('defer-image')
  })

  SetImages($images, PreloadImages(imagesGroup))
}

export default DeferImages
